export class SameCallbackRequestError extends Error {
  constructor() {
    super();
    this.name = 'sameCallbackRequestError';
  }
}
